import Application from "Application";
import WhatsAppLogo from 'components/icons/whatsapp/logo-whatsapp.svg';

class WhatsAppService {
    private whatsappButton: HTMLAnchorElement;

    constructor() {
        this.whatsappButton = document.createElement("a");
    }

    init(): void {
        const app = Application.getInstance();
        if (!app.showWhatsAppChat) {
            return;
        }

        this.whatsappButton.href = app.whatsAppLink;
        this.whatsappButton.target = '_blank';
        this.whatsappButton.className = app.showCrispChat ? "whatsapp-button crisp-button" : "whatsapp-button";
        this.whatsappButton.id = "WhatsAppBtn";

        const whatsappIcon = document.createElement("img");
        whatsappIcon.src = WhatsAppLogo;
        whatsappIcon.alt = "WhatsApp";
        this.whatsappButton.appendChild(whatsappIcon);

        document.body.appendChild(this.whatsappButton);
    }

    show(): void {
        this.whatsappButton.style.display = 'block';
    }

    hide(): void {
        this.whatsappButton.style.display = 'none';
    }
}

const whatsappService = new WhatsAppService();
export default whatsappService;
